export type ModalKind =
  | 'login_first_run'
  | 'locked_prerequisite'
  | 'locked_cooldown'
  | 'delete_confirmation'
  | 'critical_error';

export type DismissBehavior = 'DISMISS' | 'REQUIRED_ACTION';

export interface ModalKindDefaults {
  defaultTitle: string;
  defaultBody: string;
  primaryLabel: string;
  secondaryLabel?: string;
  priority: number;
  dismissBehavior: DismissBehavior;
}

export const MODAL_REGISTRY: Record<ModalKind, ModalKindDefaults> = {
  login_first_run: {
    defaultTitle: 'Welcome to BrainWrk',
    defaultBody: 'You\'re all set. Start exploring your learning pathways or jump into a chat session.',
    primaryLabel: 'Get started',
    secondaryLabel: 'Maybe later',
    priority: 10,
    dismissBehavior: 'DISMISS',
  },
  locked_prerequisite: {
    defaultTitle: 'Complete the prerequisites first',
    defaultBody: 'Finish the previous modules to unlock this content.',
    primaryLabel: 'Go to prerequisites',
    secondaryLabel: 'Dismiss',
    priority: 20,
    dismissBehavior: 'DISMISS',
  },
  locked_cooldown: {
    defaultTitle: 'Come back soon',
    defaultBody: 'This content will be available after a short cooldown period.',
    primaryLabel: 'Got it',
    priority: 20,
    dismissBehavior: 'DISMISS',
  },
  delete_confirmation: {
    defaultTitle: 'Are you sure?',
    defaultBody: 'This action cannot be undone.',
    primaryLabel: 'Delete',
    secondaryLabel: 'Cancel',
    priority: 30,
    dismissBehavior: 'DISMISS',
  },
  critical_error: {
    defaultTitle: 'Something went wrong',
    defaultBody: 'An unexpected error occurred. Please reload the page and try again.',
    primaryLabel: 'Reload page',
    priority: 50,
    dismissBehavior: 'REQUIRED_ACTION',
  },
};

export function getModalDefaults(kind: ModalKind): ModalKindDefaults {
  return MODAL_REGISTRY[kind];
}
